import React, { useState, useContext, useEffect } from "react";

import { StoreContext } from "../store";

import Image from "react-bootstrap/Image";
import ImageModal from "./atoms/molecules/ImageModal";
//import Filter from "./atoms/molecules/filter";
import ContactUsModal from "./atoms/molecules/ContactUsModal";
import UploadBirdModal from "./atoms/molecules/UploadBirdModal";
import DeleteConfirmation from "./atoms/molecules/DeleteConfirmation";
import { GetBirds } from "../actions";

let Blog = (props) => {
  //const baseUrl = "http://localhost:64567";
  const { dispatch, AuthToken, Products, IsLogin, BaseURL } = useContext(
    StoreContext
  );
  //const [filter, setFilter] = useState("All");
  const [showContactModal, setShowContactModal] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [birds, setBirds] = useState();
  useEffect(() => {
    if (Products.length == 0) GetBirds(dispatch);
  }, []);
  //const birds = Products?.filter((item) => item.Page == props.Page);

  useEffect(() => {
    let birds = Products?.filter((item) => item.Page == props.Page);
    setBirds(birds);
  }, [Products.length]);

  function getRootUrl() {
    var defaultPorts = { "http:": 80, "https:": 443 };

    return (
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port &&
      window.location.port != defaultPorts[window.location.protocol]
        ? ":" + window.location.port
        : "")
    );
  }

  // const selectFilter = (event) => {
  //   setFilter(event.value);
  // };

  const hideModalClick = () => {
    setShowContactModal(false);
  };

  const handleShowContact = () => {
    setShowContactModal(true);
  };

  const renderAdmin = (bird) => {
    return (
      <React.Fragment>
        {" "}
        <div className="col-item">
          <div style={{ textAlign: "left" }}>
            <UploadBirdModal Text="Edit Article" Bird={bird}></UploadBirdModal>{" "}
          </div>
        </div>
        <div className="col-item">
          <DeleteConfirmation
            show={showConfirmDeleteModal}
            closeModal={() => hideModalClick()}
            Bird={bird}
            Msg={`Are you sure you want to delete ${bird.Title} ?`}
          ></DeleteConfirmation>
        </div>
      </React.Fragment>
    );
  };
  const renderBird = (bird) => {
    const imageURL = bird.Files.filter(
      (file) => file.includes("jpg") || file.includes("png")
    );
    return (
      <div className="blog-container">
        <div class="description">
          <div>
            <span style={{ fontWeight: "bold" }}>{bird.Title} </span>
            <br />
            {/* {new Date(bird.Created).toDateString()}
            <br /> */}
            <br />
            {bird.Description}
            <br />
            {bird.Page == "forsale" ? bird.Price : null}
          </div>
        </div>
        <div className="col-container">
          {imageURL == "" ? null : (
            <div className="col-item">
              <Image
                src={
                  BaseURL +
                  "/UploadedFiles/wingandaprayerloft/Catalog/" +
                  imageURL
                }
                alt={bird.Title}
                style={{ width: "auto", height: "300px" }}
              />
            </div>
          )}

          {IsLogin ? renderAdmin(bird) : null}
        </div>
      </div>
    );
  };

  const renderItems = () => {
    return (
      <React.Fragment>
        {birds?.length > 0 ? (
          birds
            .sort(
              (a, b) =>
                b.SortingIndex - a.SortingIndex ||
                new Date(b.Created) - new Date(a.Created)
            )
            ?.map((filteredBird) => renderBird(filteredBird))
        ) : (
          <span style={{ color: "red", fontWeight: "bolder" }}>No Result</span>
        )}
      </React.Fragment>
    );
  };
  //test
  return (
    <React.Fragment>
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        {IsLogin ? (
          <div style={{ textAlign: "left" }}>
            <UploadBirdModal Text="Add Article"></UploadBirdModal>{" "}
          </div>
        ) : null}
      </div>
      <div
        style={{
          flexGrow: 2,
          display: "flex",
          justifyContent: "space-around",
          width: "100%",
          marginBottom: "10px",
          flexWrap: "wrap",
          // borderTop: "1px solid gray",
          // borderRadius: "10px",
        }}
      >
        {renderItems()}
      </div>
    </React.Fragment>
  );
};

export default Blog;
